/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
import { Logger } from '../../common/Logger.js';
const logger = Logger.get('Route.ts');
export class Route {
    _raw;
    lang;
    _replaceLang = true;
    constructor(_raw, lang) {
        this._raw = _raw;
        this.lang = lang;
    }
    raw() {
        return this._raw;
    }
    /**
     * By default, :lang is replaced, you can disable it by calling replaceLang(false).
     * @param value
     */
    replaceLang(value) {
        this._replaceLang = value;
        return this;
    }
    /**
     * Template lang and remove optional parameters.
     */
    format() {
        const result = this._raw.replace(/:[a-z0-9]+\?\/?/gi, '');
        return this.replaceParam(result, 'lang', this.getLang());
    }
    withParams(params) {
        let result = this._raw;
        for (const key in params) {
            const value = params[key];
            if (typeof value === 'string') {
                result = this.replaceParam(result, key, value);
            }
            else {
                logger.error(`Invalid value supplied for ${key} in route: ${this._raw}`);
            }
        }
        if (this._replaceLang) {
            return this.replaceParam(result, 'lang', this.getLang());
        }
        else {
            return result;
        }
    }
    getLang() {
        return typeof this.lang === 'function' ? this.lang() : this.lang;
    }
    replaceParam(input, key, value) {
        const replaced = input.replace(new RegExp(`:${key}\\??`), value);
        if (replaced === input) {
            logger.error(`Parameters ${key} have not been found in route: ${this._raw}`);
        }
        return replaced;
    }
}
//# sourceMappingURL=Route.js.map